import Image from "next/image";
import Link from "next/link";
import { DEFAULT_AVATAR } from "../../utils/image";
const WriterDesctiption = (props: any) => {
  const author = props.writerData[0];
  const authorHref = `/tag/${author._id}?type=author&title=${encodeURIComponent(author.displayName)}`;
  return (
    <div className="flex gap-4 bg-theme-card p-4 md:p-5">
      <Link href={authorHref} aria-label={author.displayName} className="relative h-[53px] w-[53px] shrink-0 cursor-pointer overflow-hidden rounded-full bg-theme-surface">

        <Image
          src={
            author.pictureProfile
              ? author.pictureProfile
              : DEFAULT_AVATAR
          }
          width={53}
          height={53}
          alt=""
          className="h-[53px] w-[53px] rounded-full object-cover"
        />

      </Link>
      <div className="flex min-w-0 flex-col justify-center gap-1">
        <Link
          href={authorHref}
          className="text-[17px] font-semibold leading-snug text-theme-text transition-colors hover:text-signal dark:hover:text-[#8DB4FF]">
          {`${author.displayName}`}
        </Link>
        {author.desc ? (
          <p className="m-0 text-[15px] leading-relaxed text-theme-text-secondary">{`${author.desc}`}</p>
        ) : null}
      </div>
    </div>
  );
};

export default WriterDesctiption;
